// Produccion: consumo de insumos, desvio contra costo estandar y mermas.
// Recibe todo ya calculado: cargar y agregar es cosa de la pantalla.

import React from 'react';
import { ClipboardList, RefreshCw, Scale, Trash2 } from 'lucide-react';
import { formatDateLong, formatInt, formatMoney, formatPercent, formatQty } from './formato';
import { DataTable, EmptyState, SectionCard } from './componentes';

export default function TabProduccion({
  consumoInsumos,
  desviacionCostos,
  extraLoaded,
  extraLoading,
  mermas,
}) {
  return (
            <>
              <SectionCard
                title="Consumo de insumos y materias primas"
                icon={ClipboardList}
                action={
                  extraLoading.produccion && <RefreshCw size={14} className="text-slate-400 animate-spin" />
                }
              >
                {extraLoading.produccion && !extraLoaded.produccion ? (
                  <EmptyState icon={ClipboardList} message="Cargando producción…" />
                ) : (
                  <DataTable
                    emptyMessage="Sin producción registrada en el período"
                    rows={consumoInsumos}
                    columns={[
                      { key: 'nombre', label: 'Insumo', cellClass: () => 'font-black text-slate-800 truncate max-w-[260px]' },
                      { key: 'cant', label: 'Cantidad', align: 'right', cellClass: () => 'font-bold text-slate-600', render: (r) => formatQty(r.cant) },
                      { key: 'costo', label: 'Costo', align: 'right', cellClass: () => 'font-black text-slate-900', render: (r) => `$ ${formatMoney(r.costo)}` },
                    ]}
                  />
                )}
              </SectionCard>

              <SectionCard title="Desviación de costos de producción" icon={Scale}>
                {extraLoading.produccion && !extraLoaded.produccion ? (
                  <EmptyState icon={Scale} message="Cargando producción…" />
                ) : (
                  <DataTable
                    emptyMessage="Sin producción registrada en el período"
                    rows={desviacionCostos}
                    columns={[
                      { key: 'nombre', label: 'Producto', cellClass: () => 'font-black text-slate-800 truncate max-w-[200px]' },
                      { key: 'cantidad', label: 'Producido', align: 'right', cellClass: () => 'font-bold text-slate-600', render: (r) => formatInt(r.cantidad) },
                      { key: 'teoricoTotal', label: 'Costo estándar', align: 'right', cellClass: () => 'text-slate-500', render: (r) => `$ ${formatMoney(r.teoricoTotal)}` },
                      { key: 'realTotal', label: 'Costo real', align: 'right', cellClass: () => 'font-black text-slate-900', render: (r) => `$ ${formatMoney(r.realTotal)}` },
                      { key: 'desvio', label: 'Desvío', align: 'right', cellClass: (r) => `font-black ${r.desvio > 0 ? 'text-rose-600' : r.desvio < 0 ? 'text-emerald-600' : 'text-slate-500'}`, render: (r) => `${r.desvio > 0 ? '+' : ''}$ ${formatMoney(r.desvio)}` },
                      { key: 'desvioPct', label: '%', align: 'right', cellClass: (r) => `font-black ${r.desvio > 0 ? 'text-rose-600' : r.desvio < 0 ? 'text-emerald-600' : 'text-slate-500'}`, render: (r) => (r.teoricoTotal > 0 ? formatPercent(r.desvioPct) : '-') },
                    ]}
                  />
                )}
              </SectionCard>

              <SectionCard
                title="Mermas y desperdicios"
                icon={Trash2}
                action={
                  mermas.length > 0 && (
                    <span className="text-[10px] font-black uppercase tracking-widest text-rose-600">
                      {formatQty(mermas.reduce((a, m) => a + m.cant, 0))} ud.
                    </span>
                  )
                }
              >
                {extraLoading.movimientos && !extraLoaded.movimientos ? (
                  <EmptyState icon={Trash2} message="Cargando movimientos…" />
                ) : (
                  <DataTable
                    emptyMessage="Sin mermas registradas en el período"
                    rows={mermas}
                    columns={[
                      { key: 'nombre', label: 'Producto', cellClass: () => 'font-black text-slate-800 truncate max-w-[220px]' },
                      { key: 'cant', label: 'Cantidad', align: 'right', cellClass: () => 'font-black text-rose-600', render: (m) => formatQty(m.cant) },
                      { key: 'eventos', label: 'Eventos', align: 'right', cellClass: () => 'text-slate-500', render: (m) => formatInt(m.eventos) },
                      { key: 'ultimoMotivo', label: 'Último motivo', cellClass: () => 'text-slate-600 truncate max-w-[200px]', render: (m) => m.ultimoMotivo || '-' },
                      { key: 'ultimo', label: 'Fecha', align: 'right', cellClass: () => 'text-slate-500', render: (m) => formatDateLong(m.ultimo) },
                    ]}
                  />
                )}
                <p className="mt-3 text-[10px] font-medium text-slate-400">
                  Se reconocen como merma los movimientos de stock cuyo tipo o motivo menciona merma, rotura, vencimiento, deterioro o descarte.
                </p>
              </SectionCard>
            </>
  );
}
